import React, { useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { FormGroup } from '@blueprintjs/core';
import { fetchAllQuestionTypes } from 'actions/utils';
import Row from 'containers/Reports/row';
import { DatePicker } from '@blueprintjs/datetime';
import { runArchivedReport } from 'actions/reports';
import moment from 'moment';
import { getMaxDate } from 'utils/functions';

const dateDirectionOptions = [
  { label: 'Before', value: 'before' },
  { label: 'On', value: 'on' },
  { label: 'After', value: 'after' },
];

const ArchivedQuestionsBase = ({
  fetchAllQuestionTypes,
  types,
  isFetching,
  isLoaded,
  runArchivedReport,
  report,
  ...rest
}) => {
  const [selectedDate, setDate] = useState(new Date());
  const [selectedType, setType] = useState(null);
  const [selectedDirection, setDirection] = useState(dateDirectionOptions[0]);

  const handleChange = (selected, setter) => {
    setter(selected);
  };
  return (
    <Row
      name="Archived Questions"
      description="All questions that have been archived."
      drawer={
        <div style={{ width: '50%' }}>
          <FormGroup label="Question Type">
            <Select
              options={types}
              isLoading={isFetching}
              getOptionLabel={option => option.typeName}
              getOptionValue={option => option.typeID}
              value={selectedType}
              onChange={selected => handleChange(selected, setType)}
            />
          </FormGroup>
          <FormGroup label="Date Before, On or After">
            <Select
              options={dateDirectionOptions}
              value={selectedDirection}
              onChange={selected => handleChange(selected, setDirection)}
            />
          </FormGroup>
          <FormGroup label="Date">
            <DatePicker
              value={selectedDate}
              onChange={selected => handleChange(selected, setDate)}
              maxDate={getMaxDate()}
            />
          </FormGroup>
        </div>
      }
      runReport={() =>
        runArchivedReport({
          questionnaireType: selectedType ? selectedType.typeID : null,
          direction: selectedDirection.value,
          date: moment(selectedDate).format('YYYY-MM-DD'),
        })
      }
      data={report}
      headers={[
        { label: 'Question Type', key: 'questionType' },
        { label: 'Question', key: 'question' },
        { label: 'Date Archived', key: 'archivedDate' },
        { label: 'Weight', key: 'weight' },
        { label: 'Control Number', key: 'controlID' },
        { label: 'Date Created', key: 'createDate' },
        { label: 'Answers', key: 'answers' },
      ]}
      resetDrawerState={() => {
        setDate(new Date());
        setDirection(dateDirectionOptions[0]);
        setType(null);
      }}
      fetchReportFieldsData={() => {
        if (!isLoaded) {
          fetchAllQuestionTypes();
        }
      }}
      {...rest}
    />
  );
};

const mapStateToProps = state => ({
  types: state.utils.questionTypes,
  isFetching: state.utils.isFetchingTypes,
  isLoaded: state.utils.isLoadedTypes,
  report: state.reports.archivedQuestions,
  isFetchingReport: state.reports.isFetching,
  isLoadedReport: state.reports.isLoaded,
  errorMessage: state.reports.errorMessage,
});

const ArchivedQuestions = connect(
  mapStateToProps,
  { fetchAllQuestionTypes, runArchivedReport }
)(ArchivedQuestionsBase);

export default ArchivedQuestions;
